import React from 'react';
import './Loader.css';

const Loader = ({ fullScreen = true, text = 'Loading' }) => {
  const content = (
    <div className="loader-container">
      <div className="loader-crystal">
        <img src="/logo.png" alt="UltraCapital" className="loader-logo" />
        <div className="crystal-ring crystal-ring-1"></div>
        <div className="crystal-ring crystal-ring-2"></div>
        <div className="crystal-ring crystal-ring-3"></div>
        <div className="crystal-shard crystal-shard-1"></div>
        <div className="crystal-shard crystal-shard-2"></div>
        <div className="crystal-shard crystal-shard-3"></div>
        <div className="crystal-shard crystal-shard-4"></div>
        <div className="crystal-shard crystal-shard-5"></div>
        <div className="crystal-shard crystal-shard-6"></div>
      </div>
      <div className="loader-particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <div key={i} className="frost-particle" style={{
            '--delay': `${Math.random() * 3}s`,
            '--x': `${Math.random() * 200 - 100}px`,
            '--y': `${Math.random() * 200 - 100}px`,
            '--size': `${Math.random() * 4 + 2}px`,
            '--duration': `${Math.random() * 2 + 2}s`,
          }}></div>
        ))}
      </div>
      <div className="loader-text">
        <span>{text}</span>
        <span className="loader-dots">
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </span>
      </div>
      <div className="loader-frost-line"></div>
    </div>
  );

  if (fullScreen) {
    return <div className="loader-fullscreen">{content}</div>;
  }
  return content;
};

export default Loader;
